import { Label } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingPromoLabelProps {
  text: string;
}

export const NewbuildingPromoLabel: React.FC<INewbuildingPromoLabelProps> = ({ text }) => {
  return (
    <div className={styles['label']}>
      <Label color="white_100" background="error_100">
        {text}
      </Label>
    </div>
  );
};
